var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.activeDaughterId
        ? _c(
            "div",
            { staticClass: "font-italic warning--text title" },
            [
              _vm._v("\n    Lien vers la fille :\n    "),
              _c("link-to-request", {
                attrs: {
                  "request-id": _vm.activeDaughterId,
                  "property-id": _vm.active.property_id
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.active && _vm.active.mother_request_id
        ? _c(
            "div",
            { staticClass: "font-italic warning--text title" },
            [
              _vm._v("\n    Lien vers la mère :\n    "),
              _c("link-to-request", {
                attrs: {
                  "request-id": _vm.active.mother_request_id,
                  "property-id": _vm.active.property_id,
                  "daugther-id": _vm.activeId
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-expansion-panels",
        {
          attrs: { accordion: "", flat: "", multiple: "" },
          model: {
            value: _vm.panel,
            callback: function($$v) {
              _vm.panel = $$v
            },
            expression: "panel"
          }
        },
        [
          _c(
            "display-expansion-panel",
            { staticClass: "border-bottom" },
            [
              _c(
                "display-expansion-panel-header",
                { staticClass: "font-weight-bold text-uppercase px-0" },
                [_vm._v("\n        Informations\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                { staticClass: "panel-pa-0" },
                [
                  _c("request-infos", {
                    staticClass: "mb-2",
                    attrs: { isRequestLogOpen: _vm.isRequestLogOpen }
                  }),
                  _vm._v(" "),
                  _c("attachment-menu", {
                    attrs: { "request-id": _vm.activeId }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "display-expansion-panel",
            { staticClass: "border-bottom" },
            [
              _c(
                "display-expansion-panel-header",
                { staticClass: "font-weight-bold text-uppercase px-0" },
                [_vm._v("\n        Journal des actions\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                { staticClass: "panel-pa-0" },
                [_c("request-logs-table")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "title primary--text d-flex flex-wrap" }, [
      _c("span", { staticStyle: { "white-space": "nowrap" } }, [
        _vm._v("Demandes d'")
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "font-weight-bold",
          staticStyle: { "white-space": "nowrap" }
        },
        [_vm._v("\n      interventions\n    ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }